import { HydraListResponse, ListResponse } from "@/types";

export const deserializeHydraListResponse = <T>({
  "hydra:member": items,
  "hydra:totalItems": totalItems,
}: HydraListResponse<T>): ListResponse<T> => ({
  items,
  totalItems,
});
